module.exports = __webpack_public_path__ + "static/media/47.a81a29ee.png";